import { Dragable } from '../dragable/index.js'

const template = `<ui-modal id="ui-modal"></ui-modal>`

export class UiFloatModal {
    constructor(content, resizable = false, edges = null) {
        this.root = document.createElement('div')
        this.root.innerHTML = template
        this.modalComponent = this.root.querySelector('ui-modal')
        if (content.nodeType) this.modalComponent.appendChild(content)
        else this.modalComponent.innerHTML = content
        this.uiModal = new Dragable(this.root, this.modalComponent.modalHeader, resizable, edges)
        this.modalComponent.uiModal = this.uiModal
        this.modalComponent.root = this.root
        this.modalComponent.rootDestroy = this.destroy.bind(this);
    }
    destroy(){
        if (this.uiModal) {
            this.uiModal.destroy();
            this.uiModal = null;
        }
        if (this.modalComponent && this.modalComponent.parentElement) {
            this.modalComponent.parentElement.removeChild(this.modalComponent);
            this.modalComponent = null;
        }

        this.root = null;
    }
}